import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { getToken } from "../../utils/getToken";

export interface CategoryQueryParam {
  search?: string;
  module?: string;
  admin?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}

export const useGetAuditTrailQuery = ({
  search,
  module,
  admin,
  startDate,
  endDate,
  page,
  limit,
}: CategoryQueryParam) => {
  const token = getToken();

  const queryParams = new URLSearchParams();
  if (search) queryParams.append("search", search);
  if (module) queryParams.append("module", module);
  if (admin) queryParams.append("admin", admin);
  if (startDate) queryParams.append("startDate", startDate);
  if (endDate) queryParams.append("endDate", endDate);
  if (page) queryParams.append("page", `${page}`);
  if (limit) queryParams.append("limit", `${limit}`);

  return useQuery({
    queryKey: [
      "getAuditTrail",
      search,
      module,
      admin,
      startDate,
      endDate,
      page,
      limit,
    ],
    queryFn: () =>
      axiosInstance
        .get(`/admins/audit-trails?${queryParams.toString()}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),
    enabled: !!token,
  });
};
